query GetCompanyRecordTypes {
  companyRecordTypes {
    id
    name
    description
    salesforceId
  }
}
